import type { Configuration } from '@mnd-frontend/ui/public/components/Button';
import { WEB_PURPLE_REG, WEB_RED_REG } from '@mnd-frontend/ui/shared/tokens';
import type { ButtonVariants } from '../Button/styling';

export function moduleBackgroundToCSS(bgColor?: string | (string | null)[] | null): string {
  let backgroundColor = 'var(--color-white)';
  const color = bgColor && Array.isArray(bgColor) ? bgColor[0] : bgColor;
  if (color?.includes('gradient-2')) {
    backgroundColor =
      'linear-gradient(289.69deg, rgb(78, 73, 199) 8.94%, rgb(255, 68, 115) 80.65%);';
  } else if (color?.includes('gradient-3')) {
    backgroundColor = 'linear-gradient(rgb(24, 22, 70) 0%, rgb(78, 73, 199) 100%);';
  } else if (color?.includes('red')) {
    backgroundColor = 'var(--color-primary, #ff4473)';
  } else if (color?.includes('pink')) {
    backgroundColor = 'var(--color-pink, #ffc3d2)';
  } else if (color?.includes('orange')) {
    backgroundColor = 'var(--color-orange, #ffac70)';
  } else if (color?.includes('deep-purple')) {
    backgroundColor = 'var(--color-deep-purple, #181646)';
  } else if (color?.includes('purple')) {
    backgroundColor = 'var(--color-purple, #4e49c7)';
  } else if (color?.includes('gray')) {
    backgroundColor = 'var(--color-lightgray, #f5f5f6)';
  } else if (color?.includes('transparent')) {
    backgroundColor = 'transparent';
  }
  return backgroundColor;
}

export function chooseLightOrDarkTextColor(bgColor?: string | (string | null)[] | null): string {
  const color = bgColor && Array.isArray(bgColor) ? bgColor[0] : bgColor;
  if (
    color?.includes('gradient-3') ||
    color?.includes('gradient-2') ||
    color?.includes('purple') ||
    color?.includes('red') ||
    color?.includes('deep-purple')
  ) {
    return 'var(--color-white, #fff)';
  } else {
    return 'var(--text-color, #181646)';
  }
}

export function chooseButtonColorBasedOnBackground(
  bgColor?: (string | null)[] | null,
): ButtonVariants {
  if (
    bgColor?.includes('gradient-2') ||
    bgColor?.includes('pink') ||
    bgColor?.includes('deep-purple') ||
    bgColor?.includes('gray')
  ) {
    return 'purple';
  } else if (bgColor?.includes('red')) {
    return 'white';
  } else {
    return 'primary';
  }
}
export function chooseSecondaryButtonColorBasedOnPrimaryButton(
  buttonColor: ButtonVariants,
): ButtonVariants {
  if (buttonColor === 'primary') {
    return 'transparentPrimary';
  } else if (buttonColor === 'purple') {
    return 'transparentPurple';
  } else if (buttonColor === 'white') {
    return 'transparentWhite';
  }
  return buttonColor;
}

export function getColorForCheckmark(bgColor?: (string | null)[] | null): string {
  if (bgColor?.includes('red') || bgColor?.includes('gradient-2')) {
    return WEB_PURPLE_REG;
  } else {
    return WEB_RED_REG;
  }
}

export type WPColorScheme = 'pink' | 'purple';

const schemeToButtonConfiguration: Record<WPColorScheme, Configuration[]> = {
  pink: ['primary', 'tertiary'],
  purple: ['secondary', 'tertiary'],
};

export const getButtonConfigurationBasedOnColorScheme = ({
  colorScheme,
  index,
}: {
  colorScheme: WPColorScheme;
  index: number;
}) => {
  const configs = schemeToButtonConfiguration[colorScheme];
  return configs[index] ?? configs[0];
};

export const isBackgroundDark = (bgColor?: (string | null)[] | null) => {
  const color = bgColor && Array.isArray(bgColor) ? bgColor[0] : bgColor;
  return !!(
    color?.includes('gradient-3') ||
    color?.includes('gradient-2') ||
    color?.includes('purple') ||
    color?.includes('red') ||
    color?.includes('deep-purple')
  );
};
